var EEnvironmentName = /*#__PURE__*/ function(EEnvironmentName) {
    EEnvironmentName["Development"] = "development";
    EEnvironmentName["Staging"] = "staging";
    EEnvironmentName["Production"] = "production";
    return EEnvironmentName;
}(EEnvironmentName || {});
var EEnvironmentProtocol = /*#__PURE__*/ function(EEnvironmentProtocol) {
    EEnvironmentProtocol["http"] = "http";
    EEnvironmentProtocol["https"] = "https";
    return EEnvironmentProtocol;
}(EEnvironmentProtocol || {});
export { EEnvironmentName, EEnvironmentProtocol };
